<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="101 Things to Do With Canned Biscuits">
<div class="recto">
<h1><a id="d0e2">101 Things to Do With Canned Biscuits</a></h1><a id="d0e2">
<h3>Toni Patrick</h3>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</a></div><a id="d0e2">
</a></div><a id="d0e2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// recto.vue?4bf2d473